import { ArrowUpRight } from "lucide-react";
import { IMG, BOOKING_URL, scrollToId } from "../content";
import { Reveal } from "./Reveal";

const Offer = ({ title, price, children, testid }) => (
  <article className="offer" data-testid={testid}>
    <header className="offer-head">{title}</header>
    <div className="offer-body">
      <div className="offer-price" data-testid={`${testid}-price`}>{price}</div>
      {children}
    </div>
  </article>
);

const Coaching = () => {
  const book = () => {
    if (BOOKING_URL) {
      window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
    } else {
      scrollToId("contact");
    }
  };

  return (
    <section id="coaching" className="coaching section-pad" data-testid="coaching-section">
      <Reveal className="section-head-center">
        <p className="eyebrow" data-testid="coaching-eyebrow">Work together</p>
        <h2 className="section-heading">Private 1:1 Online Coaching</h2>
        <p className="section-sub">Personalized coaching for mindset, movement and recovery.</p>
      </Reveal>
      <Reveal delay={0.08} className="coaching-banner">
        <img src={IMG.practice} alt="A young athlete rising for a shot during a basketball game" loading="lazy" />
      </Reveal>
      <div className="offer-grid">
        <Reveal delay={0.1}>
          <Offer title="60-Minute 1:1 Session" price="$135" testid="coaching-single-offer">
            <p className="offer-note">Choose one coach</p>
            <p className="offer-coach">Agnieszka</p>
            <p className="offer-spec">Mindset &amp; Mental Performance</p>
            <p className="offer-or">or</p>
            <p className="offer-coach">Nika</p>
            <p className="offer-spec">Mobility, Recovery &amp; Nervous-System Regulation</p>
          </Offer>
        </Reveal>
        <Reveal delay={0.22}>
          <Offer title="90-Minute Integrated Session" price="$250" testid="coaching-integrated-offer">
            <p className="offer-note">Work with both coaches</p>
            <p className="offer-coach">45 minutes with Agnieszka</p>
            <p className="offer-spec">Mindset &amp; Mental Performance</p>
            <p className="offer-or">and</p>
            <p className="offer-coach">45 minutes with Nika</p>
            <p className="offer-spec">Mobility, Recovery, Breathwork &amp; Regulation</p>
          </Offer>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="coaching-cta">
        <button type="button" className="btn btn-primary" onClick={book} data-testid="coaching-booking-cta">
          Book / Inquire About a Session <ArrowUpRight size={16} />
        </button>
      </Reveal>
    </section>
  );
};

export default Coaching;
